/** QC Moisture Data Verification (manual p171): the Review link off the verification list. */
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { MoistureReviewPage } from "@/features/quality/components/moisture/moisture-review-page";

export const Route = createFileRoute("/_app/quality/moisture/$sampleId")({
  params: {
    parse: ({ sampleId }) => {
      if (!/^\d+$/.test(sampleId)) throw notFound();
      return { sampleId };
    },
    stringify: (p) => p,
  },
  beforeLoad: () => {
    if (!useAuth.getState().can("qc.verify")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { sampleId } = Route.useParams();
  return <MoistureReviewPage id={Number(sampleId)} />;
}
